(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

export default function combineReducers(produce) {
  let reducers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const keys = Object.keys(reducers);
  const initialState = keys.reduce((a, k) => {
    // eslint-disable-next-line
    a[k] = reducers[k](undefined, {});
    return a;
  }, {});
  return produce((draft, action) => {
    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i]; // eslint-disable-next-line

      draft[key] = reducers[key](draft[key], action);
    }

    return draft;
  }, initialState);
}
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(combineReducers, "combineReducers", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/utils/combineReducers.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();